export default "__VITE_ASSET__b6577c60__"